import { createAsyncThunk } from '@reduxjs/toolkit';
import { storeResources } from '../../resources';
import { getUserData } from '../../../services/user';
import { IUserData } from '../../../services/user/types';

export const ThunkGetUserData = createAsyncThunk<IUserData>(
  `${storeResources.USER}/getUserData`,
  () => getUserData().then(res => res.data),
);
